/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationRequirementExpirationStatus;

(function (ValidationRequirementExpirationStatus) {
  ValidationRequirementExpirationStatus["EXPIRED"] = "expired";
  ValidationRequirementExpirationStatus["EXPIRE_SOON"] = "expire_soon";
  ValidationRequirementExpirationStatus["URGENT_EXPIRING"] = "urgent_expiring";
})(ValidationRequirementExpirationStatus || (ValidationRequirementExpirationStatus = {}));